import { html } from 'lit';
const Pill =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M15 6.5H9a5.5 5.5 0 1 0 0 11h6a5.5 5.5 0 1 0 0-11M9 5a7 7 0 0 0 0 14h6a7 7 0 1 0 0-14z" clip-rule="evenodd"/>
  </svg>
`;
export default Pill;
